import React from 'react';
import { UMALandingPage } from './UMALandingPage';

/**
 * /find-programs/medical-program-search
 *
 * The same ZIP-first medical program search, presented under the Online
 * College Guide nav rather than UMA's own branding — so the page reads as a
 * neutral search tool instead of a school's landing page.
 */
export function UMAMedicalProgramSearchPage() {
  return <UMALandingPage zipFirst showBrandHeader={false} backUrl="/find-programs/medical-program-search" data-id="element-3432" data-mp="2kqc88w6whg4r" />;
}